import axios from "axios";
import { resolveApiUrl } from "../../assets/GlobalVariables";

/**
 * Submit a public Ops contact inquiry (no session required).
 * @param {{
 *   full_name: string,
 *   phone?: string,
 *   email?: string,
 *   message: string,
 *   source_channel: 'interested' | 'business',
 *   source_url: string,
 * }} payload
 */
export async function submitPublicOpsContact(payload) {
  const resolvedUrl = resolveApiUrl("/api/public/ops-contact");
  const { data } = await axios.post(resolvedUrl, payload || {}, {
    withCredentials: true,
    timeout: 20000,
    headers: { "Content-Type": "application/json" },
  });
  return data;
}

export async function fetchPublicOpsChat(token) {
  const t = String(token || "").trim();
  if (!t) throw new Error("chat_token_required");
  const resolvedUrl = resolveApiUrl(`/api/public/ops-contact/${encodeURIComponent(t)}`);
  const { data } = await axios.get(resolvedUrl, {
    withCredentials: true,
    timeout: 20000,
  });
  return data;
}

export async function postPublicOpsChatMessage(token, message) {
  const t = String(token || "").trim();
  if (!t) throw new Error("chat_token_required");
  const resolvedUrl = resolveApiUrl(
    `/api/public/ops-contact/${encodeURIComponent(t)}/messages`,
  );
  const { data } = await axios.post(
    resolvedUrl,
    { message },
    {
      withCredentials: true,
      timeout: 20000,
      headers: { "Content-Type": "application/json" },
    },
  );
  return data;
}
